/* FUKUI — the shipping policy, built as a page rather than a document.
   Runs after policy.js, on /policies/shipping-policy only, and works on the
   sections that script has already made. Every word it puts on screen is
   lifted verbatim from the policy itself: the summary cards and the delivery
   table are read out of the text, never written. If a piece cannot be read,
   that block simply does not appear and the original prose stays as it is. */
(function () {
  'use strict';

  var rte = document.querySelector('.shopify-policy__body .rte') ||
            document.querySelector('.shopify-policy__body');
  if (!rte || !rte.querySelector('.pol-sec')) return;
  document.body.classList.add('shipping-policy');

  var secs = Array.prototype.slice.call(rte.querySelectorAll('.pol-sec'));
  function section(re) {
    for (var i = 0; i < secs.length; i++) {
      var h = secs[i].querySelector('.pol-h');
      if (h && re.test(h.textContent)) return secs[i];
    }
    return null;
  }
  function clean(s) { return String(s).replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }

  /* ── the dateline belongs at the top, next to the title ──────── */
  var last = rte.lastElementChild;
  var dateP = last && last.querySelector ? last.querySelector('p > em:only-child, em') : null;
  if (dateP && /effective|updated/i.test(dateP.textContent)) {
    var host = document.querySelector('.shopify-policy__title');
    if (host) {
      var d = document.createElement('div');
      d.className = 'pol-date mono';
      d.textContent = clean(dateP.textContent);
      host.appendChild(d);
      var p = dateP.closest('p');
      (p || dateP).parentNode.removeChild(p || dateP);
    }
  }

  /* ── read the delivery zones out of their list ───────────────── */
  var zoneSec = section(/delivery after dispatch/i);
  var zoneList = zoneSec ? zoneSec.querySelector('ul') : null;
  var zones = [];
  if (zoneList) {
    Array.prototype.slice.call(zoneList.children).forEach(function (li) {
      var strong = li.querySelector('strong');
      if (!strong) return;
      var label = clean(strong.textContent).replace(/:$/, '');
      var rest = clean(li.textContent).slice(clean(strong.textContent).length).replace(/^[:\s]+/, '');
      /* the em dash separates the time from the cost; the en dash inside
         "2–5" must survive, so only the em dash is a separator */
      var bits = rest.split(/\s*—\s*/);
      zones.push({
        label: label,
        time: bits.length > 1 ? bits[0] : '',
        cost: bits.length > 1 ? bits.slice(1).join(' — ') : '',
        note: bits.length > 1 ? '' : rest,
        html: li.innerHTML
      });
    });
  }

  /* ── the production time, as the document states it ──────────── */
  var prodSec = section(/production|dispatch time/i);
  var prodValue = '';
  if (prodSec) {
    var b = prodSec.querySelector('p strong');
    if (b) prodValue = clean(b.textContent);
  }

  /* ── 1. the three numbers people open this page for ──────────── */
  var cards = [];
  if (prodValue && prodSec) {
    cards.push({ k: clean(prodSec.querySelector('.pol-h').textContent), v: prodValue, s: '', href: '#' + prodSec.id });
  }
  zones.filter(function (z) { return z.cost; }).slice(0, 2).forEach(function (z) {
    cards.push({ k: z.label, v: z.cost, s: z.time, href: zoneSec ? '#' + zoneSec.id : '' });
  });

  if (cards.length >= 2) {
    var strip = document.createElement('div');
    strip.className = 'ship-facts';
    strip.innerHTML = cards.map(function (c) {
      return '<a class="fact" href="' + c.href + '">' +
        '<span class="k mono">' + c.k + '</span>' +
        '<span class="v">' + c.v + '</span>' +
        (c.s ? '<span class="s mono">' + c.s + '</span>' : '') +
        '</a>';
    }).join('');
    rte.parentNode.insertBefore(strip, rte);

    strip.addEventListener('click', function (e) {
      var a = e.target.closest('a.fact');
      if (!a || a.getAttribute('href').charAt(0) !== '#') return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 84, behavior: 'smooth' });
    });
  }

  /* ── 2. the zones read better as a table than as bullets ─────── */
  if (zoneList && zones.length && zones.some(function (z) { return z.time; })) {
    var table = document.createElement('table');
    table.className = 'ship-table';
    table.innerHTML =
      '<thead><tr><th>Destination</th><th>After dispatch</th><th>Cost</th></tr></thead><tbody>' +
      zones.map(function (z) {
        if (!z.time) return '<tr><th scope="row">' + z.label + '</th><td colspan="2">' + z.note + '</td></tr>';
        return '<tr><th scope="row">' + z.label + '</th><td>' + z.time + '</td><td class="c">' + z.cost + '</td></tr>';
      }).join('') + '</tbody>';
    var wrap = document.createElement('div');
    wrap.className = 'ship-tablewrap';
    wrap.appendChild(table);
    zoneList.parentNode.replaceChild(wrap, zoneList);
  }

  /* ── 3. the lead-time list, as a pair of plain rows ──────────── */
  var leadSec = section(/lead time/i);
  var leadList = leadSec ? leadSec.querySelector('ul') : null;
  if (leadList) {
    var rows = Array.prototype.slice.call(leadList.children).map(function (li) {
      var strong = li.querySelector('strong');
      if (!strong) return '<div class="row"><span>' + clean(li.textContent) + '</span></div>';
      var label = clean(strong.textContent).replace(/:$/, '');
      var rest = clean(li.textContent).slice(clean(strong.textContent).length).replace(/^[:\s]+/, '');
      return '<div class="row"><span>' + label + '</span><b>' + rest + '</b></div>';
    }).join('');
    var lead = document.createElement('div');
    lead.className = 'ship-lead';
    lead.innerHTML = rows;
    leadList.parentNode.replaceChild(lead, leadList);
  }

  /* ── 4. the contact line, set out instead of run together ────── */
  var contactSec = section(/^contact/i);
  if (contactSec) {
    var cp = contactSec.querySelector('p');
    var txt = cp ? clean(cp.textContent) : '';
    var mail = (txt.match(/[\w.+-]+@[\w-]+\.[a-z]{2,}/i) || [])[0];
    if (cp && mail) {
      /* the leading pictogram, if the policy has one */
      var emoji = (txt.match(/^[^\w\s]+/) || [''])[0].trim();
      var rest2 = txt.slice(emoji.length).replace(mail, '').replace(/\s+/g, ' ').trim();

      var box = document.createElement('div');
      box.className = 'ship-contact';
      box.innerHTML =
        '<p class="line">' + (emoji ? '<span class="emo">' + emoji + '</span>' : '') +
        '<a class="mail" href="mailto:' + mail + '">' + mail + '</a></p>' +
        (rest2 ? '<p class="hours">' + rest2 + '</p>' : '');
      cp.parentNode.replaceChild(box, cp);
    }
  }
})();
